module.exports = __webpack_public_path__ + "static/img/PE.3cbaf4a8.svg";